// extracted by mini-css-extract-plugin
export default {"mainPage":"MainPage_mainPage__lTDaz","container_top":"MainPage_container_top__myQOf","container":"MainPage_container__-Vb6u"};